import { render, staticRenderFns } from "./StaticTimer.vue?vue&type=template&id=fa34336e&scoped=true&lang=pug&"
import script from "./StaticTimer.vue?vue&type=script&lang=js&"
export * from "./StaticTimer.vue?vue&type=script&lang=js&"
import style0 from "./StaticTimer.vue?vue&type=style&index=0&id=fa34336e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa34336e",
  null
  
)

export default component.exports